import React, { useState, useEffect } from 'react';
import { View, StyleSheet, Platform, Modal } from 'react-native';
import { useNavigation } from '../context/NavigationContext';
import { useAuth } from '../context/AuthContext';
import LoadingScreen from '../components/LoadingScreen';
import SubscriptionSuccessScreen from '../components/SubscriptionSuccessScreen';
import SubscriptionErrorScreen from '../components/SubscriptionErrorScreen';

const SuccessScreen = () => {
    const { navigateTo } = useNavigation();
    const { user, loading: authLoading } = useAuth();
    
    const [loading, setLoading] = useState(true);
    const [subscriptionStatus, setSubscriptionStatus] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Only check subscription status when auth is fully loaded and user is available
        if (!authLoading && user) {
            checkSubscriptionStatus();
        } else if (!authLoading && !user) {
            // Auth is loaded but no user - show error
            setLoading(false);
            setSubscriptionStatus('error');
            setError('User not authenticated. Please log in and try again.');
        }
    }, [authLoading, user]);

    const checkSubscriptionStatus = async () => {
        try {
            if (user) {
                // Check user's subscription status in Firestore
                if (user.subscription) {
                    // Check for subscription status in the nested structure
                    const subscriptionData = user.subscription;
                    const status = subscriptionData?.subscriptionStatus;
                    
                    
                    if (status === 'active') {
                        setSubscriptionStatus('success');
                    } else {
                        setSubscriptionStatus('error');
                        setError(`Subscription not activated. Current status: ${status || 'none'}. Please try again.`);
                    }
                } else {
                    setSubscriptionStatus('error');
                    setError('User not found. Please try again.');
                }
            } else {
                setSubscriptionStatus('error');
                setError('User not authenticated. Please log in and try again.');
            }
        } catch (error) {
            console.error('Error checking subscription status:', error);
            setSubscriptionStatus('error');
            setError('Failed to verify subscription. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleRetry = () => {
        setLoading(true);
        setSubscriptionStatus(null);
        setError(null);
        checkSubscriptionStatus();
    };

    const handleReturnToPlans = () => {
        navigateTo('Plans');
    };

    const handleContinue = () => {
        navigateTo('Home');
    };

    if (loading || authLoading) {
        return (
            <Modal visible={true} transparent={false} animationType="fade">
                <LoadingScreen 
                    onComplete={() => setLoading(false)}
                    loadingText="VERIFYING SUBSCRIPTION"
                />
            </Modal>
        );
    }

    if (subscriptionStatus === 'success') {
        return (
            <Modal visible={true} transparent={false} animationType="fade">
                <SubscriptionSuccessScreen onContinue={handleContinue} />
            </Modal>
        );
    }

    if (subscriptionStatus === 'error') {
        return (
            <Modal visible={true} transparent={false} animationType="fade">
                <SubscriptionErrorScreen 
                    onRetry={handleRetry}
                    onReturnToPlans={handleReturnToPlans}
                />
            </Modal>
        );
    }

    // Fallback - should not reach here
    return null;
};

const styles = StyleSheet.create({
    // Styles are now handled by the individual components
});

export default SuccessScreen;
